import { GuardedDeletionService } from 'orchestrator';
import { Component, inject } from '@angular/core';
import { ForestrySituationService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ForestrySituationCreateDto,
  ForestrySituationDto,
  ForestrySituationExcelDownloadDto,
  ForestrySituationUpdateDto,
} from '../proxy/planning/dtos/forestry-situation';
import { FORESTRYSITUATION_CONFIG, FORESTRYSITUATION_FIELDS } from './forestry-situation.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-forestry-situation',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, ForestrySituationService, ConfirmationService],
  templateUrl: './forestry-situation.html',
  styleUrl: './forestry-situation.scss',
})
export class ForestrySituation extends BaseCrudComponent<
  ForestrySituationDto,
  ForestrySituationCreateDto,
  ForestrySituationUpdateDto,
  ForestrySituationExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  service = {
    ...inject(ForestrySituationService),
    deleteByIds: (ids: number[]) => this.guardedDeletion.deleteByIds('ForestrySituation', ids),
  };
  config = FORESTRYSITUATION_CONFIG;
  fields = FORESTRYSITUATION_FIELDS;

  protected prepareUpdateDto(data: any, selected: ForestrySituationDto): ForestrySituationUpdateDto {
    return {
      name: data.name,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'ForestrySituation';
  }
}
